module.exports = __webpack_public_path__ + "img/pool-bar-img.bae67cc6.jpg";